import React from 'react';
import Image from '@nubank/nuds-web/components/Image/Image';
import Box from '@nubank/nuds-web/components/Box/Box';

function SectionImages() {
  return (
    <Box
      tag="section"
      backgroundColor="primary.default"
      display="flex"
      justifyContent="center"
      alignItems="center"
      paddingVertical={{ xs: '3x', md: '20x', lg: '12x' }}
      paddingHorizontal={{ xs: '3x', md: '12x', lg: 195 }}
    >
      <Image
        loading="lazy"
        srcSet={{
          xs: 'computer-desk-man/computer-desk-man@xs-1x.jpg',
          md: 'computer-desk-man/computer-desk-man@md-1x.jpg',
          lg: 'computer-desk-man/computer-desk-man@lg-1x.jpg',
        }}
        altIntlKey="ABOUT_US.IMAGES.ALT"
      />
    </Box>
  );
}

export default React.memo(SectionImages);
